module.exports = __webpack_public_path__ + "38d711c24.jpg";